<template>
  <el-dialog
      class="special_dialog"
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      custom-class="editFormDialog"
      :close-on-click-modal="false"
      :title="$lang('编辑订单')"
      :visible.sync="dialogVisible"
      @close="closeDialog">
    <jms-form :option="formOpt" :loading="btnLoading" v-model="formData" ref="jmsForm" @submit="onSubmit" @cancel="closeDialog"></jms-form>
  </el-dialog>
</template>
<script>
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
import { checkAddressFormat, phoneAndMobileInter, RULES } from '@utils/rules'
import { getComCost, getSettlement } from '@api/module/customer'
import debounce from 'lodash/debounce'
import JmsForm from '@components/jms-widget/jms-form-sec/index.vue'
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'EditForm',
  data() {
    return {
      btnLoading: false,
      formData: {},
      dialogVisible: false,
      provinceArray: [],
      cityList: [],
      startAddressId: null,
      endAddressId: null,
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      choiceType: 1,
      expressType: [{
        code: 'ExportUAE',
        name: 'Export From UAE'
      }]
    }
  },
  components: {
    JmsForm
  },
  props: {
    rowResult: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    rowResult: {
      handler (val) {
        this.formData = cloneDeep({ ...val })
        this.$nextTick(async () => {
          await this.getProList(this.formData.senderCountryId || '')
          await this.getCurrencyTypeList()
          if (this.formData.senderProvinceId) {
            await this.handleProvice(this.formData.senderProvinceId, 1)
          }
        })
      },
      deep: true,
    }
  },
  computed: {
    ...mapState({
      countryList: state => {
        return state.base.countryList
      }
    }),
    formOpt() {
      const self = this
      return {
        menuWidth: 100,
        menuBtn: false,
        group: [
          {
            label: '寄件人信息',
            prop: 'sendInfo',
            column: [
              {
                label: '国家',
                prop: 'senderCountryCode',
                type: 'select',
                dicData: [{ code: self.$lang('UAE'), name: self.$lang('UAE') }],
                props: {
                  value: 'code',
                  label: 'name'
                },
                rules: [RULES.requiredSelect],
                change: (val) => {
                  if (val) {
                    self.changeCountryName('senderPhoneAreacode')
                  }
                }
              },
              {
                label: '姓名',
                prop: 'senderName',
                minlength: 1,
                maxlength: 30,
                rules: [RULES.requiredTrim],
                placeholder: '请输入'
              },
              {
                label: '手机',
                prop: 'senderMobilePhone',
                maxlength: 15,
                rules: [RULES.required, { validator: phoneAndMobileInter }],
                placeholder: '请输入'
              },
              {
                label: '公司',
                prop: 'senderCompany',
                minlength: 1,
                maxlength: 100,
                placeholder: '请输入'
              },
              {
                label: '邮箱',
                prop: 'senderEmail',
                minlength: 1,
                maxlength: 150,
                rules: [{ type: 'email', message: this.$lang('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }],
                placeholder: '请输入'
              },
              {
                label: '寄件酋长国',
                prop: 'senderProvinceId',
                type: 'select',
                dicData: this.provinceArray,
                filterable: true,
                props: {
                  label: 'nativeName',
                  value: 'id'
                },
                rules: [RULES.requiredSelect],
                change: (val) => {
                  if (val) {
                    self.dataProvinceChange(val, 1)
                  } else {
                    self.formData.senderCityId = null
                    self.cityList = []
                  }
                }
              },
              {
                label: '寄件城市',
                prop: 'senderCityId',
                type: 'select',
                dicData: this.cityList,
                filterable: true,
                disabled: !this.formData.senderProvinceId,
                props: {
                  label: 'nativeName',
                  value: 'id'
                },
                rules: [RULES.requiredSelect],
                change: (val) => {
                  if (val) {
                    self.dataCityChange(val)
                  }
                }
              },
              {
                label: '寄件区域',
                prop: 'senderAreaId',
                type: 'select',
                dicData: this.areaList,
                filterable: true,
                props: {
                  label: 'nativeName',
                  value: 'id'
                },
                change: (val) => {
                  if (val) {
                    self.dataAreaChange(val)
                  }
                }
              },
              {
                label: '寄件街道',
                prop: 'senderStreet',
                minlength: 1,
                maxlength: 12,
                placeholder: '请输入'
              },
              {
                label: '详细地址',
                prop: 'senderDetailedAddress',
                minlength: 4,
                maxlength: 200,
                span: 4,
                type: 'textarea',
                placeholder: '请输入',
                rules: [RULES.required, { validator: checkAddressFormat }]
              }
            ]
          },
          {
            label: '收件人信息',
            prop: 'receiveInfo',
            column: [
              {
                label: '国家',
                prop: 'receiverCountryName',
                type: 'select',
                dicUrl: '/vip/order/international/outer/listAllCountry',
                props: {
                  value: 'countryName',
                  label: 'countryName'
                },
                filterable: true,
                rules: [RULES.requiredSelect]
              },
              {
                label: '姓名',
                prop: 'receiverName',
                minlength: 1,
                maxlength: 30,
                rules: [RULES.requiredTrim],
                placeholder: '请输入'
              },
              {
                label: '手机',
                prop: 'receiverMobilePhone',
                maxlength: 15,
                rules: [RULES.required, { validator: phoneAndMobileInter }],
                placeholder: '请输入'
              },
              {
                label: '证件号',
                prop: 'receiverIdCard',
                minlength: 1,
                maxlength: 30,
                placeholder: '请输入'
              },
              {
                label: '邮箱',
                prop: 'receiverEmail',
                minlength: 1,
                maxlength: 150,
                rules: [{ type: 'email', message: this.$lang('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }],
                placeholder: '请输入'
              },
              {
                label: '公司',
                prop: 'receiverCompany',
                minlength: 1,
                maxlength: 150,
                placeholder: '请输入'
              },
              {
                label: '邮编',
                prop: 'receiverPostalCode',
                minlength: 1,
                maxlength: 60,
                rules: [RULES.requiredTrim],
                placeholder: '请输入'
              },
              {
                label: '收件省份',
                prop: 'receiverProvinceName',
                rules: [RULES.requiredSelect]
              },
              {
                label: '收件城市',
                prop: 'receiverCityName',
                rules: [RULES.requiredSelect]
              },
              {
                label: '收件区域',
                prop: 'receiverAreaName'
              },
              {
                label: '收件街道',
                prop: 'receiverStreet',
                minlength: 1,
                maxlength: 12,
                placeholder: '请输入'
              },
              {
                label: '详细地址',
                prop: 'receiverDetailedAddress',
                type: 'textarea',
                minlength: 4,
                maxlength: 200,
                span: 4,
                placeholder: '请输入',
                rules: [RULES.required, { validator: checkAddressFormat }]
              }
            ]
          },
          {
            label: '货物信息',
            prop: 'goodInfo',
            column: [
              {
                label: '长(cm)',
                prop: 'packageLength',
                precision: 2,
                min: 0,
                type: 'number',
                max: 9999999.99,
                placeholder: '请输入'
              },
              {
                label: '宽(cm)',
                prop: 'packageWide',
                precision: 2,
                min: 0,
                type: 'number',
                max: 9999999.99,
                placeholder: '请输入'
              },
              {
                label: '高(cm)',
                prop: 'packageHigh',
                precision: 2,
                min: 0,
                type: 'number',
                max: 9999999.99,
                placeholder: '请输入'
              },
              {
                label: '产品类型',
                prop: 'expressTypeCode',
                type: 'select',
                props: {
                  label: 'name',
                  value: 'code'
                },
                dicData: this.expressType,
                rules: [RULES.requiredSelect]
              },
              {
                label: '备注',
                prop: 'remarks',
                minlength: 1,
                maxlength: 50,
                type: 'textarea',
                placeholder: '请输入',
                span: 4
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    openEditSuccess(type) {
      this.dialogVisible = true
      this.choiceType = type
    },
    async onSubmit() {
      this.btnLoading = true
      if (this.formData.payment) {
        const paymentkey = Object.keys(this.formData.payment).some((item) => {
          return this.formData.payment[item] === null
        })
        if (paymentkey) {
          this.formData.payment = null
        }
      }
      if (this.formData.goods) {
        const goodskey = Object.keys(this.formData.goods).some((item) => {
          return this.formData.goods[item] === null
        })
        if (goodskey) {
          this.formData.goods = null
        }
      }
      await this.$emit('edit-save', JSON.parse(JSON.stringify(this.formData)), 2)
      this.btnLoading = false
    },
    closeDialog() {
      this.formData = {}
      this.btnLoading = false
      this.dialogVisible = false
    },
    changeCountryName (code, key) {
      if (this.countryList.length > 0) {
        const obj = this.countryList.find(item => item.code === code)
        this.formData[key] = obj.areaCode
        this.getProList(obj.id || '')
        this.clearCity('sender')
        this.clearProvince('sender')
      }
    },
    async getProList (countryId) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 2, countryId })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data || []
      } else {
        this.$message.error(msg)
      }
    },
    clearCity (type) {
      if (type === 'sender') {
        this.formData.senderCityId = ''
        this.formData.senderCityName = ''
      } else {
        this.formData.receiverCityId = ''
        this.formData.receiverCityName = ''
      }
    },
    clearProvince (type) {
      if (type === 'sender') {
        this.formData.senderProvinceId = ''
        this.formData.senderProvinceName = ''
      } else {
        this.formData.receiverProvinceId = ''
        this.formData.receiverProvinceName = ''
      }
    },
    dataProvinceChange (value) {
      if (value) {
        this.getCityList(value)
      }
      this.formData.senderAreaName = ''
      this.formData.senderAreaId = ''
    },
    async getCityList (parentId) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data || []
        this.formData.senderProvinceId = parentId
        this.formData.senderCityId = data[0].id
        this.formData.senderCityName = data[0].nativeName
        let obj = {}
        obj = this.provinceArray.find((item) => {
          return item.id === parentId
        })
        this.formData.senderProvinceName = obj.nativeName
        this.senderExpressTypeData = data[0].products || []
        this.getAreaList(data[0].id)
      } else {
        this.$message.error(msg)
      }
    },
    dataCityChange (value) {
      this.formData.senderCityId = value
      if (this.cityList.length > 0) {
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.formData.senderCityName = obj.nativeName
        this.senderExpressTypeData = obj.products || []
      }
      this.getAreaList(value)
    },
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        if (data && data.length > 0) {
          this.areaList = data
          this.formData.senderAreaName = data[0].nativeName
          this.formData.senderAreaId = data[0].id
        }
      } else {
        this.$message.error(msg)
      }
    },
    dataAreaChange(value) {
      this.formData.senderAreaId = value
      const obj = this.areaList.find((item) => {
        return item.id === value
      })
      this.formData.senderAreaName = obj.nativeName
    },
    async handleProvice (provinceId) {
      const { data, code, msg } = await Api.GET_AREA_INTER({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data || []
        const item = data.find(({ id }) => id === this.formData.senderCityId)
        if (item) this.senderExpressTypeData = item.products || []
      } else {
        this.$message.error(msg)
      }
    },
    calcStandardCost: debounce(async function (data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, paymentModeId, expressTypeCode } = data
      const obj = {}
      const promises = [
        await this.getSettlement(senderProvinceId, senderCityId),
        await this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      if (startAddressId && endAddressId && expressTypeCode) {
        const res = await this.getComCost(startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
        this.formData.standardValue = res.cost
        this.formData.settlementWeight = res.setWeight
      }
    }, 200),
    async getSettlement (providerId, cityId, areaId, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost (number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode, productTypeCode, serviceMethodCode: '01' }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
  }
}
</script>
<style lang="scss">
.el-dialog__wrapper .el-dialog.editFormDialog {
  margin-bottom: 0 !important;
}
.el-dialog__wrapper .el-dialog.editFormDialog .el-dialog__body {
  max-height: 700px;
  overflow: auto;
  padding: 10px 20px;
  .dialog-footer {
    border-top: 0;
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
</style>
<style scoped lang="scss">
.special_dialog {
  ::v-deep {
    .avue-form__group {
      background: #f7f7f9;
      padding: 20px 20px 10px;
      border-radius: 8px;
    }

  }
}
</style>
